import React, { useCallback, useState } from "react";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactionsWrapper } from "./ReactionsWrapper";
import { useAPI } from "../../providers/ApiProvider";
import { motion } from "framer-motion";
import { debounce } from "lodash";
import { faThumbsUp as thumbsUpSolid } from "@fortawesome/free-solid-svg-icons";
import { faThumbsUp as thumbsUpRegular } from "@fortawesome/free-regular-svg-icons";
import { useAppStore } from "../../providers/AppStoreProvider";

export const ANIMATION_CONFIG = {
  visible: {
    display: "flex",
    visibility: "visible",
    transition: {
      delayChildren: 0.1,
      when: "beforeChildren",
    },
  },

  hidden: {
    display: "none",
    transition: {
      when: "afterChildren",
    },
  },

  closed: {
    display: "none",
  },
};

export const ReactionButton = observer(({ comment }) => {
  const { comments } = useAppStore();
  const api = useAPI();

  const [liked, setLiked] = useState(comment?.reaction?.type);
  const [animate, setAnimate] = useState(false);
  const [loading, setLoading] = useState(false);
  let handle = null;

  const debounceLike = useCallback(
    debounce((newType) => {
      api
        .callApi("reactComment", {
          params: { pk: comment.id },
          body: {
            type: newType,
          },
        })
        .then((res) => {
          const { reaction, reacts } = res.data;
          let commentInstance = comments.find((c) => comment.id === c.id);

          if (!commentInstance) {
            for (const c of comments) {
              commentInstance = c.childComments?.find((child) => child.id === comment.id);

              if (commentInstance) {
                break;
              }
            }
          }

          if (commentInstance) {
            commentInstance.setReaction(reaction);
            commentInstance.setReacts(reacts);

            if (commentInstance.reaction?.status === "active") {
              setLiked(commentInstance.reaction?.type);
            } else setLiked(null);
          }
        })
        .finally((e) => setLoading(false));
    }, 500),
    [],
  );

  const likeHandler = (newType = "like") => {
    setAnimate("closed");
    setLoading(true);

    debounceLike(newType);
  };

  const mouseOverHandler = () => {
    if (handle) {
      clearTimeout(handle);
      handle = null;
    }
    setAnimate("visible");
  };

  const mouseLeaveHandler = () => {
    handle = setTimeout(() => {
      setAnimate("hidden");
    }, 1000);
  };

  return (
    <div className="like-thumb" onMouseOver={mouseOverHandler} onMouseLeave={mouseLeaveHandler}>
      <div
        role="button"
        className={`comment-action py-2 ${liked ? liked : ""} ${loading ? "disabled" : ""}`}
        onClick={() => likeHandler(liked)}
      >
        {liked === "like" && (
          <>
            <FontAwesomeIcon icon={thumbsUpSolid} className="me-2" />
            Thích
          </>
        )}
        {!liked && (
          <>
            <FontAwesomeIcon icon={thumbsUpRegular} className="me-2" />
            Thích
          </>
        )}
        {liked !== "like" && liked && (
          <>
            <img
              width="16"
              height="16"
              src={`${process.env.PUBLIC_URL}/assets/icons/${liked}.svg`}
              alt="love"
              className="me-2"
            />
            {liked === "love" && "Yêu thích"}
            {liked === "haha" && "Haha"}
            {liked === "wow" && "Wow"}
          </>
        )}
      </div>
      <motion.div initial="hidden" animate={animate} variants={ANIMATION_CONFIG}>
        <ReactionsWrapper animate={animate} setLike={(val) => likeHandler(val)} />
      </motion.div>
    </div>
  );
});
